import React from "react";
import { HeadingWithList } from "./HeadingWithLIst";

const LISTELEMENTS: JSX.Element[] = [
  <p className="text-gray-500 pb-2" key="pp-list-1">
    <span className="font-semibold text-black">{"Registration data"}</span>
    {`: such as Name,Email ID, Mobile Number.
`}
  </p>,
  <div className="text-gray-500 pb-2" key="pp-list-2">
    <p className="pb-4">
      <span className="font-semibold text-black">{"Tracking Information"}</span>
      {`: Such as, but not limited to the IP address of your device and Device ID when connected to the Internet. This information may include the URL that you just came from (whether this URL is on the Website or not), which URL you next go to (whether this URL is on the Website or not), your computer or device browser information, and other information associated with your interaction with the Website;`}
    </p>
    <p>
      {`This privacy policy also applies to data we collect from users who are not registered as members of this Website, including, but not limited to, browsing behaviour, pages viewed etc. We also collect and store personal information provided by You from time to time on the Website. We only collect and use such information from you that we consider necessary for achieving a seamless, efficient and safe experience, customized to your needs including: `}
      <div className="mt-4">
      {[
        "i. To enable the provision of services opted for by you;",
        "ii. To enable the viewing of content in your interest;",
        "iii. To communicate the necessary account and service-related information from time to time;",
        "iv. To allow you to receive quality customer care services and data Collection;",
        "v. To comply with applicable laws, rules and regulations;",
      ].map((content, index) => {
        return (
          <p className="" key={index}>
            {content}
          </p>
        );
      })}
    </div>
    </p>

  </div>,

  <p className="text-gray-500 pb-2 " key="pp-list-3">
    <span className="font-semibold text-black">{"Third party requests"}</span>
    {`: Where any service requested by You involves a third party, such information as is reasonably necessary by the Company to carry out Your service request may be shared with such third party. We also do use your contact information to send you offers based on your interests and prior activity and also to view the content preferred by you. The Company may also use contact information internally to direct its efforts for service improvement but shall immediately delete all such information upon withdrawal of your consent for the same through the ‘unsubscribe’ button or through an email to be sent to contact@auctionbazaar.comc`}
  </p>,

<p className="text-gray-500 pb-2 " key="pp-list-4">
{`To the extent possible, we provide you with the option of not divulging any specific information that you wish for us not to collect, store or use. You may also choose not to use a particular service or feature on the Website and opt-out of any non-essential communications from the Website.`}
</p>,

<p className="text-gray-500 pb-2 " key="pp-list-5">
{`Further, transacting over the internet has inherent risks which can only be avoided by you following security practises yourself, such as not revealing account/login related information to any other person and informing our customer care team about any suspicious activity or where your account has/may have been compromised.`}
</p>,

  
];

export const ListSection = () => {
  return (
    <HeadingWithList
      heading=""
      headingStyles="text-gray-500 font-bold text-2xl py-4"
      listElements={LISTELEMENTS}
    />
  );
};
